import React, { useEffect, useState } from 'react';
import { useFinishSetPinQuery } from '../../../hooks/query/useFinishSetPinQuery';
import { useStore } from '../../../store';
import { useGetLinkToSetPinQuery } from '../../../hooks/query/useGetLinkToSetPinQuery';
import Spinner, { SpinnerColor } from '../../../generic-components/Spinner';
import { SET_PIN_STYLES } from '../constants';
import { getMostRelevantCard } from '../../../helpers/cardStatus.helper';

interface IProps {
  setShowSuccessPopup: () => void;
}
const SetPinFlow = ({ setShowSuccessPopup }: IProps) => {
  const { customerId } = useStore(state => state.currUser());
  const { getPersonalAccount } = useStore(state => state);
  const cardId = getMostRelevantCard(getPersonalAccount().cards)?.cardId;

  const [pinStatus, setPinStatus] = useState<number>(10);

  const { data: changePinResponse, refetch: changePin } = useGetLinkToSetPinQuery({
    customerId, cardId,
  });

  const { refetch: finishSetPin } = useFinishSetPinQuery({
    customerId, cardId, pinStatus, onSuccess: () => { setShowSuccessPopup(); },
  });

  useEffect(() => {
    if (!changePinResponse) changePin();
  }, [changePinResponse]);

  useEffect(() => {
    window.addEventListener('message', (event) => {
      // Below URL is modified for production:
      if (event.origin !== 'https://agserv-lili.pd.gpsrv.com') {
        return;
      }
      const statusCode: number = event.data;
      setPinStatus(statusCode);
      finishSetPin();
      // if (statusCode)
    }, false);
    return () => {
      window.removeEventListener('message', () => {});
    };
  }, []);
  return changePinResponse?.url ? <iframe data-testid='iframe-changePin' className={SET_PIN_STYLES.IFRAME} title={SET_PIN_STYLES.IFRAME_TITLE} src={changePinResponse.url} /> : (
    <Spinner
      spinnerColor={SpinnerColor.Blue}
      height={SET_PIN_STYLES.SPINNER_SIZE}
      width={SET_PIN_STYLES.SPINNER_SIZE}
    />
  );
};

export default SetPinFlow;
